module.exports = "<div class=\"fourzerofour__container\">\n  <h1>404</h1>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/404/404.component.html
// module id = ./src/app/pages/404/404.component.html
// module chunks = main